import { numberToPrettyString } from '@cian/utils';
import { IPromo } from '../../../../../types/newbuilding/promos';

export const getInterestRate = (promo: IPromo): string => {
  const interestRate = promo.mortgageParams?.interestRate;

  if (!interestRate && interestRate !== 0) {
    return '—';
  }

  const roundedNumber = Math.round(interestRate * 100) / 100;

  return `${numberToPrettyString(roundedNumber)}%`;
};
